const getters = {
  panelState: (state) => state.panelState,
  userState: (state) => state.userState,
};

export default getters;
